// @ts-nocheck
import { Loading, Authenticated, useGetOne, GetOneParams } from "react-admin";
import { Box } from "@mui/material";
import React from "react";

const CallRecords = () => {
  const {
    data: dataDashboard,
    isLoading: loadingDashboard,
    error: errorDashboard,
  } = useGetOne("dashboard", { id: 294 } as GetOneParams);

  if (loadingDashboard) {
    return <Loading />;
  }
  if (errorDashboard) {
    console.log({ error: errorDashboard });
  }

  return (
    <Authenticated>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          typography: "body1",
          padding: "15px",
        }}
      >
        {dataDashboard && dataDashboard.metabaseUrl && (
          <iframe
            title="Overall"
            frameBorder={0}
            src={dataDashboard.metabaseUrl}
            width="100%"
            height="100%"
            allowTransparency
          />
        )}
      </Box>
    </Authenticated>
  );
};

export default CallRecords;
